import baseAPI from '@/api/base';
import {
  EditOrganization,
  GetOrganization,
  RegisterOrganization,
} from '@/dtos/organization.dto';
import {
  DELETE_ORGANIZATION_URL,
  EDIT_ORGANIZATION_URL,
  GET_ORGANIZATION_URL,
  REGISTER_ORGANIZATION_URL,
  SIGNUP_ORGANIZATION_URL,
  TOGGLE_ORGANIZATION_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Organization {
  static getOrganizations = async (
    getOrganization: GetOrganization
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ORGANIZATION_URL, {
      params: getOrganization,
    });
    console.log('response', response);
    return response;
  };

  static registerOrganization = async (
    registerOrganization: RegisterOrganization
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_ORGANIZATION_URL,
      {
        ...registerOrganization,
      }
    );
    console.log('response', response);
    return response;
  };

  static signupOrganization = async (
    registerOrganization: RegisterOrganization
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      SIGNUP_ORGANIZATION_URL,
      {
        ...registerOrganization,
      }
    );
    console.log('response', response);
    return response;
  };

  static editOrganization = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_ORGANIZATION_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static toggleOrganizationIsActive = async (
    editOrganization: EditOrganization
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ORGANIZATION_IS_ACTIVE_URL,
      {
        ...editOrganization,
      }
    );
    return response;
  };

  static deleteOrganization = async (
    userId: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ORGANIZATION_URL}/${userId}`
    );
    return response;
  };
}

export default Organization;
